import { render } from "./TankReportVengurlaOffline.vue?vue&type=template&id=8b51ee02&scoped=true"
import script from "./TankReportVengurlaOffline.vue?vue&type=script&lang=js"
export * from "./TankReportVengurlaOffline.vue?vue&type=script&lang=js"

import "./TankReportVengurlaOffline.vue?vue&type=style&index=0&id=8b51ee02&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b51ee02"]])

export default __exports__